import type { Filter } from '~/types/filter'
import { toGrossSliderRange } from '~/utils/products'

export const WATER_CATEGORY_CODE = 'CP-09'
export const WATER_CATEGORY_SLUG = 'voda'
export const WATER_BRAND_QUERY_KEY = 'brand'

const LOGO_BASE = '/images/water-logos'

export const WATER_BRAND_LOGO_BY_CODE: Record<string, string | string[]> = {
  'NFV-00120': `${LOGO_BASE}/aronitsa-aronica.avif`,
  'NFV-00121': `${LOGO_BASE}/Baldaran-Logo.avif`,
  'NFV-00123': `${LOGO_BASE}/white.avif`,
  'NFV-00125': `${LOGO_BASE}/velingrad-velingrad-mineralna.avif`,
  'NFV-00126': [
    `${LOGO_BASE}/gorna-banya-gorna-banya-sinya-tochka.avif`,
    `${LOGO_BASE}/gorna-banya-1-gorna-banya.avif`,
  ],
  'NFV-00127': [
    `${LOGO_BASE}/DEVIN-logo.avif`,
    `${LOGO_BASE}/devin-spring.avif`,
  ],
  'NFV-00129': `${LOGO_BASE}/divna-divna-trapezna-voda.avif`,
  'NFV-00131': `${LOGO_BASE}/jivna.avif`,
  'NFV-00134': `${LOGO_BASE}/knyajevo-knyazhevo-cherveno.avif`,
  'NFV-00135': `${LOGO_BASE}/knyajevska-knyazhevska.avif`,
  'NFV-00137': `${LOGO_BASE}/kom.avif`,
  'NFV-00138': `${LOGO_BASE}/kristal.avif`,
  'NFV-00139': `${LOGO_BASE}/mihalkovo.avif`,
  'NFV-00140': `${LOGO_BASE}/pelisterka-pelisterka.avif`,
  'NFV-00142': `${LOGO_BASE}/Predela-Logo.avif`,
  'NFV-00143': `${LOGO_BASE}/rilana-rilana.avif`,
  'NFV-00147': [
    `${LOGO_BASE}/Sevtopolis_Trapezna_logo-1.avif`,
    `${LOGO_BASE}/Sevtopolis_Izvorna_logo-2.avif`,
  ],
  'NFV-00148': `${LOGO_BASE}/serdika-kids-serdika-za-deca-trapezna-voda.avif`,
  'NFV-00154': `${LOGO_BASE}/hisarya-hisarya-mineralna.avif`,
  'NFV-00112': `${LOGO_BASE}/filette.avif`,
  'NFV-00119': `${LOGO_BASE}/acqua-panna-akva-pana.avif`,
  'NFV-00118': `${LOGO_BASE}/adva-1.avif`,
  'NFV-00195': `${LOGO_BASE}/black-detox.avif`,
  'NFV-00122': `${LOGO_BASE}/borjomi-bordzhomi.avif`,
  'NFV-00130': `${LOGO_BASE}/evian.avif`,
  'NFV-00152': `${LOGO_BASE}/fiji-water-vector-logo.avif`,
  'NFV-00153': `${LOGO_BASE}/fonte-margherita-fonte-margerita.avif`,
  'NFV-00133': `${LOGO_BASE}/icelandic-logo.avif`,
  'NFV-00132': `${LOGO_BASE}/isbre-logo.avif`,
  'NFV-00128': `${LOGO_BASE}/Logo-Dzhermuk1.avif`,
  'NFV-00113': `${LOGO_BASE}/nice.avif`,
  'NFV-00141': `${LOGO_BASE}/perrier-perie.avif`,
  'NFV-00114': `${LOGO_BASE}/PRIVATE-WATER-IMMUNE-LOGO.avif`,
  'NFV-00115': `${LOGO_BASE}/h2o-logo-1.avif`,
  'NFV-00145': `${LOGO_BASE}/San_Benedetto_spa_-_logo__italy,_2019_.svg.avif`,
  'NFV-00144': `${LOGO_BASE}/s.pellegrino-san-pelegrino.avif`,
  'NFV-00146': `${LOGO_BASE}/sant-aniol-san-aniol.avif`,
  'NFV-00150': `${LOGO_BASE}/souroti-suroti.avif`,
  'NFV-00149': `${LOGO_BASE}/Logo-Naturalna-mineralna-voda-Surdzhiva-Surgiva1.avif`,
  'NFV-00151': `${LOGO_BASE}/thomas-henry.avif`,
  'NFV-00124': `${LOGO_BASE}/velamo-logo.avif`,
  'NFV-00116': `${LOGO_BASE}/watha-uota.avif`,
  'NFV-00117': `${LOGO_BASE}/wildalp-uidaup-lunna-svetlina.avif`,
}

const WATER_BRAND_META_BY_CODE: Record<string, { alt: string; ord: number }> = {
  'NFV-00120': { alt: 'Aronica', ord: 122 },
  'NFV-00121': { alt: 'Baldaran', ord: 123 },
  'NFV-00123': { alt: 'White Water', ord: 124 },
  'NFV-00125': { alt: 'Velingrad', ord: 125 },
  'NFV-00126': { alt: 'Gorna Banya', ord: 126 },
  'NFV-00127': { alt: 'Devin', ord: 127 },
  'NFV-00129': { alt: 'Divna', ord: 128 },
  'NFV-00131': { alt: 'Zhivena', ord: 129 },
  'NFV-00134': { alt: 'Knyazhevo', ord: 130 },
  'NFV-00135': { alt: 'Knyazhevska', ord: 131 },
  'NFV-00137': { alt: 'KOM', ord: 132 },
  'NFV-00138': { alt: 'Kristal', ord: 133 },
  'NFV-00139': { alt: 'Mihalkovo', ord: 134 },
  'NFV-00140': { alt: 'Pelisterka', ord: 135 },
  'NFV-00142': { alt: 'Predela', ord: 136 },
  'NFV-00143': { alt: 'Rilana', ord: 137 },
  'NFV-00147': { alt: 'Sevtopolis', ord: 138 },
  'NFV-00148': { alt: 'Serdika', ord: 139 },
  'NFV-00154': { alt: 'Hisarya', ord: 140 },
  'NFV-00112': { alt: 'Acqua Filette', ord: 141 },
  'NFV-00119': { alt: 'Acqua Panna', ord: 142 },
  'NFV-00118': { alt: 'ADVA', ord: 143 },
  'NFV-00195': { alt: 'Black DETOX', ord: 144 },
  'NFV-00122': { alt: 'Borjomi', ord: 145 },
  'NFV-00130': { alt: 'Evian', ord: 146 },
  'NFV-00152': { alt: 'Fiji', ord: 147 },
  'NFV-00153': { alt: 'Fonte Margherita', ord: 148 },
  'NFV-00133': { alt: 'Icelandic', ord: 149 },
  'NFV-00132': { alt: 'Isbre', ord: 150 },
  'NFV-00128': { alt: 'Jermuk', ord: 151 },
  'NFV-00136': { alt: 'Koh Libre', ord: 152 },
  'NFV-00113': { alt: 'Nice Water', ord: 153 },
  'NFV-00141': { alt: 'Perrier', ord: 154 },
  'NFV-00114': { alt: 'PRIVATE Water Immune', ord: 155 },
  'NFV-00115': { alt: 'Pure H2O', ord: 156 },
  'NFV-00145': { alt: 'San Benedetto', ord: 157 },
  'NFV-00144': { alt: 'San Pellegrino', ord: 158 },
  'NFV-00146': { alt: 'Sant Aniol', ord: 159 },
  'NFV-00150': { alt: 'Souroti', ord: 160 },
  'NFV-00149': { alt: 'Surgiva', ord: 161 },
  'NFV-00151': { alt: 'Thomas Henry', ord: 162 },
  'NFV-00124': { alt: 'Vellamo', ord: 163 },
  'NFV-00116': { alt: 'Watha', ord: 164 },
  'NFV-00117': { alt: 'WILDALP', ord: 205 },
}

export function getWaterBrandLogo(code: string): string | undefined {
  const entry = WATER_BRAND_LOGO_BY_CODE[code]
  if (!entry) return undefined
  return Array.isArray(entry) ? entry[0] : entry
}

export function getWaterBrandLogos(code: string): string[] {
  const entry = WATER_BRAND_LOGO_BY_CODE[code]
  if (!entry) return []
  return Array.isArray(entry) ? entry : [entry]
}

export function toWaterBrandSlug(alt: string): string {
  return alt
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function buildSlugMaps(): {
  slugByCode: Record<string, string>
  codeBySlug: Record<string, string>
} {
  const slugByCode: Record<string, string> = {}
  const codeBySlug: Record<string, string> = {}

  for (const [code, meta] of Object.entries(WATER_BRAND_META_BY_CODE)) {
    const slug = toWaterBrandSlug(meta.alt)
    if (slugByCode[code]) continue
    if (codeBySlug[slug] && codeBySlug[slug] !== code) {
      throw new Error(`Duplicate water brand slug "${slug}" for codes ${codeBySlug[slug]} and ${code}`)
    }
    slugByCode[code] = slug
    codeBySlug[slug] = code
  }

  return { slugByCode, codeBySlug }
}

const { slugByCode: WATER_BRAND_SLUG_BY_CODE, codeBySlug: WATER_BRAND_CODE_BY_SLUG } = buildSlugMaps()

export function getWaterBrandSlugByCode(code: string): string | undefined {
  return WATER_BRAND_SLUG_BY_CODE[code]
}

export function getWaterBrandCodeBySlug(slug: string): string | undefined {
  return WATER_BRAND_CODE_BY_SLUG[slug.toLowerCase()]
}

export function isWaterBrandSlug(slug: string): boolean {
  return slug.toLowerCase() in WATER_BRAND_CODE_BY_SLUG
}

export function getWaterBrandDisplayName(code: string): string | undefined {
  return WATER_BRAND_META_BY_CODE[code]?.alt
}

export function resolveBrandRedirectTarget(raw: string): string | undefined {
  if (!raw || typeof raw !== 'string') return undefined
  const trimmed = raw.trim()
  if (WATER_BRAND_SLUG_BY_CODE[trimmed]) {
    return WATER_BRAND_SLUG_BY_CODE[trimmed]
  }
  if (isWaterBrandSlug(trimmed)) {
    return trimmed.toLowerCase()
  }
  return undefined
}

export function getWaterBrandNameFromFilters(filters: Filter[], brandCode: string): string | undefined {
  for (const filter of filters) {
    if (filter.type !== 'values') continue
    const value = filter.values.find(v => v.code === brandCode)
    if (value) return value.name
  }
  return getWaterBrandDisplayName(brandCode)
}

export function applyBrandFilterFromSlug(
  filters: Filter[],
  valueFilters: Record<string, string | string[]>,
  sliderFilters: Record<string, number[]>,
  brandSlug: string,
): boolean {
  const code = getWaterBrandCodeBySlug(brandSlug)
  if (!code) return false
  return applyBrandFilterFromCode(filters, valueFilters, sliderFilters, code)
}

export function applyBrandFilterFromCode(
  filters: Filter[],
  valueFilters: Record<string, string | string[]>,
  sliderFilters: Record<string, number[]>,
  brandCode: string,
): boolean {
  for (const f of filters) {
    if (f.type === 'values') {
      if (f.allowMultipleSelect) {
        valueFilters[f.id] = []
      } else {
        valueFilters[f.id] = ''
      }
    }
    if (f.type === 'slider' && f.slider) {
      sliderFilters[f.id] = toGrossSliderRange(f.slider.minValue, f.slider.maxValue)
    }
  }

  for (const filter of filters) {
    if (filter.type !== 'values') continue
    const value = filter.values.find(v => v.code === brandCode)
    if (value) {
      valueFilters[filter.id] = value.id
      return true
    }
  }

  return false
}
